import {IWixAPI} from '@wix/yoshi-flow-editor';

export const getDeviceType = (wixCodeApi: IWixAPI): 'desktop' | 'mobile' => {
  return wixCodeApi.window.formFactor === 'Desktop' ? 'desktop' : 'mobile';
};
